<script lang="ts" setup>
import type { ProductModelV2 } from '@develop/ia-api-library'
import NotificationAddToCart from './NotificationAddToCart.vue'

withDefaults(defineProps<{
  product: ProductModelV2
  quantity?: number
  couponCode?: string
}>(), {
  quantity: 1,
})
</script>

<template>
  <NotificationAddToCart
    :item="product.name"
    :image="product.image"
    :quantity="quantity"
    :coupon-code="couponCode"
    variant="product"
  />
</template>
